import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../../components/Icons/BackArrowIcon";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../../../components/comman/ErrorMessage";
import { Spinner } from "reactstrap";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { callApi } from "../../../../ApiHelper/ApiHelper";

export default function AddShiftAndTime() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (location?.state) {
      reset({
        type: location?.state?.data?.type,
        shiftName: location?.state?.data?.shiftName,
        startTime: location?.state?.data?.startTime,
        endTime: location?.state?.data?.endTime,
        checkInBufferTime: location?.state?.data?.checkInBufferTime,
        checkOutBufferTime: location?.state?.data?.checkOutBufferTime,
      });
    }
  }, []);

  const parseTime = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const isTimeInRange = (time, startTime, endTime) => {
    const parsedTime = parseTime(time);
    const parsedStart = parseTime(startTime);
    const parsedEnd = parseTime(endTime);

    // Case 1: Time range does not span midnight
    if (parsedStart < parsedEnd) {
      return parsedTime >= parsedStart && parsedTime <= parsedEnd;
    }

    // Case 2: Time range spans midnight
    return parsedTime >= parsedStart || parsedTime <= parsedEnd;
  };

  const validations = {
    checkInBufferTime: {
      required: "Check-In Buffer Time is required",
      validate: (value) => {
        const startTime = getValues("startTime");
        const endTime = getValues("endTime");
        return (
          isTimeInRange(value, startTime, endTime) ||
          "Check-In Buffer Time must be between Start Time and End Time"
        );
      },
    },
    checkOutBufferTime: {
      required: "Check-Out Buffer Time is required",
      validate: (value) => {
        const startTime = getValues("startTime");
        const endTime = getValues("endTime");
        return (
          isTimeInRange(value, startTime, endTime) ||
          "Check-Out Buffer Time must be between Start Time and End Time"
        );
      },
    },
  };

  const onSubmit = (data) => {
    const submitData = {
      type: data?.type,
      shiftName: data?.shiftName,
      startTime: data?.startTime,
      endTime: data?.endTime,
      checkInBufferTime: data?.checkInBufferTime,
      checkOutBufferTime: data?.checkOutBufferTime,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    if (location?.state) {
      let API = apiUrl?.update_shift + `?shiftId=${location?.state?.data?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          navigate(-1);
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      let API = apiUrl?.add_shift;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          navigate(-1);
        } else {
          toast.error(response?.message);
        }
      });
    }
  };

  return (
    <>
      <>
        <div className="content container-fluid">
          <div className="content-head mb-5 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button
                role="button"
                className="btn back-arrow"
                onClick={() => navigate(-1)}
              >
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">
                {location?.state ? "Update" : "Add"} Shift &amp; Time
                Configuration
              </h1>
            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card">
              <div className="card-body">
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-BasicDetails"
                    role="tabpanel"
                    aria-labelledby="pills-BasicDetails-tab"
                    tabIndex={0}
                  >
                    <div className="row">
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="shiftName" className="form-label">
                            Work Type
                          </label>
                          <select
                            className="form-select form-control"
                            aria-label="Default select example"
                            {...register("type", {
                              required: "Work Type is required",
                            })}
                          >
                            <option value="" className="d-none">
                              Select Work Type
                            </option>
                            <option value="Office">Office</option>
                            <option value="Site">Site</option>
                          </select>
                          <ErrorMessage message={errors?.type?.message} />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="shiftName" className="form-label">
                            Shift Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Shift Name"
                            {...register("shiftName", {
                              required: "This field is Required",
                            })}
                          />
                          <ErrorMessage message={errors?.shiftName?.message} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="startTime" className="form-label">
                            Start Time
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            {...register("startTime", {
                              required: "This field is Required",
                            })}
                          />
                          <ErrorMessage message={errors?.startTime?.message} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="EndTime" className="form-label">
                            End Time
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            {...register("endTime", {
                              required: "This field is Required",
                            })}
                          />
                          <ErrorMessage message={errors?.endTime?.message} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="check-In" className="form-label">
                            Check-In Buffer Time
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            placeholder="Enter check-In"
                            {...register(
                              "checkInBufferTime",
                              {
                                required: "This field is Required",
                              },
                              validations.checkInBufferTime
                            )}
                          />
                          <ErrorMessage
                            message={errors?.checkInBufferTime?.message}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="check-Out" className="form-label">
                            Check-Out Buffer Time
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            placeholder="Enter check-Out"
                            {...register(
                              "checkOutBufferTime",
                              {
                                required: "This field is Required",
                              },
                              validations.checkOutBufferTime
                            )}
                          />
                          <ErrorMessage
                            message={errors?.checkOutBufferTime?.message}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-2 align-items-center justify-content-end">
                      <button
                        className="btn btn-secondary px-5"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary px-5" type="submit">
                        {isLoading ? (
                          <Spinner />
                        ) : location?.state ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>
    </>
  );
}
